module.exports = __webpack_public_path__ + "static/media/icon-order.fd9c2513.svg";